function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export default (function (props, propName, componentName) {
  var prop = props[propName];
  if (!(prop instanceof Element)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(prop), "` supplied to `").concat(componentName, "`, expected a DOM element."));
  }
  return null;
});